module.exports = __webpack_public_path__ + "img/magazine40.a03510de.jpg";